<div class="p-2">
  <ngx-masonry [options]="masonryOptions" [ordered]="true" class="grid" id="catalog_result-list_wrp_items">
    <div class="grid-sizer w-full lg:w-[50%] xl:w-[25%]"></div>
    @for (item of items; track item; let index = $index) {
      <div
        (click)="detail.emit(item)"
        [id]="'rec' + (index + 1)"
        class="cursor-pointer masonry-item w-full lg:w-[50%] xl:w-[25%]"
        ngxMasonryItem
        >
        <cat-result-list-masonry-simple-item
          [active]="selectIsActive(item) | async"
          [coreId]="coreId"
          [item]="item"
          [loading]="loading$ | async"
          [opened]="selectIsOpened(item) | async"
          [index]="index"
          [searchId]="searchItem.id"
        ></cat-result-list-masonry-simple-item>
      </div>
    }
  </ngx-masonry>

  <aipb-inside-loading [loading]="loading$ | async"></aipb-inside-loading>
</div>
